module.exports = __webpack_public_path__ + "static/media/school_money-logo--no-text.c4776dc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/school_money-logo--no-text.svg
// module id = 590
// module chunks = 0